import { useNavigate } from 'react-router'
import { useGame } from '../GameContext'
import { Button, WashiTape } from '../components/ui'
import { FullScorecard } from '../components/Scorecard'
import { ArrowRight } from 'lucide-react'

export default function Standings() {
  const navigate = useNavigate()
  const { gameState } = useGame()

  if (!gameState.course || gameState.players.length === 0) {
    navigate('/')
    return null
  }

  const playedHoles = gameState.holes.filter((h) => h.scores.length > 0).length

  return (
    <div className="min-h-screen flex flex-col py-6">
      <div className="text-center mb-4 relative">
        <WashiTape className="left-1/2 -translate-x-1/2 -top-3" rotation="-3deg" />
        <h1 className="text-3xl mb-1 font-hand relative z-10">Tussenstand</h1>
        <p className="text-muted-foreground">
          {playedHoles} van {gameState.course.holes} holes gespeeld
        </p>
      </div>

      <div className="flex-1 max-w-md w-full mx-auto space-y-4">
        <FullScorecard
          players={gameState.players}
          holes={gameState.holes}
          currentHole={gameState.currentHole}
        />

        <Button
          onClick={() => navigate('/play')}
          variant="outline"
          className="w-full mt-2"
          size="lg"
        >
          Verder spelen
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </div>
    </div>
  )
}